/* oph-bespoke-gallery.js — swipe-galleri. Autoplay var 2:a sekund; efter sista bilden tonar den mjukt över till bild 1 (max MAX_PASSES varv). Manuell svep/pilar är begränsade (ingen loop) som i hero. */
(function () {
  var gal = document.querySelector('[data-oph-gal]');
  if (!gal) return;
  var track = gal.querySelector('[data-gal-track]');
  var n = track.children.length;
  var prev = gal.querySelector('[data-gal-prev]');
  var next = gal.querySelector('[data-gal-next]');
  var dotsWrap = gal.querySelector('[data-gal-dots]');
  var dots = [];
  var AUTO = parseInt(gal.getAttribute('data-autoplay'), 10) || 2000;
  var MAX_PASSES = 2;   /* antal varv autoplay går innan den stannar på bild 1 */
  var FADE_MS = 350;
  var timer = null, userStopped = false, visible = false, done = false, passes = 0, fading = false;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function w() { return track.clientWidth || 1; }
  function current() { return Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / w()))); }
  function goTo(i) { i = Math.max(0, Math.min(n - 1, i)); track.scrollTo({ left: i * w(), behavior: 'smooth' }); }
  function sync() {
    var i = current();
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-active', k === i);
    if (prev) prev.classList.toggle('is-disabled', i <= 0);
    if (next) next.classList.toggle('is-disabled', i >= n - 1);
  }
  if (dotsWrap && n > 1) {
    for (var d = 0; d < n; d++) {
      (function (idx) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'oph-gal__dot'; b.setAttribute('aria-label', 'Bild ' + (idx + 1));
        b.addEventListener('click', function () { userStop(); goTo(idx); });
        dotsWrap.appendChild(b); dots.push(b);
      })(d);
    }
  }
  var ticking = false;
  track.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; sync(); });
  }, { passive: true });
  window.addEventListener('resize', function () { track.style.scrollBehavior = 'auto'; track.scrollLeft = current() * w(); track.style.scrollBehavior = ''; sync(); });
  if (prev) prev.addEventListener('click', function () { userStop(); goTo(current() - 1); });
  if (next) next.addEventListener('click', function () { userStop(); goTo(current() + 1); });
  track.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowLeft') { userStop(); goTo(current() - 1); }
    else if (e.key === 'ArrowRight') { userStop(); goTo(current() + 1); }
  });
  sync();

  /* ---- Autoplay ---- */
  function stopAuto() { if (timer) { clearInterval(timer); timer = null; } }
  function fadeToStart() {
    fading = true;
    track.classList.add('is-fading');
    setTimeout(function () {
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = 0;
      track.style.scrollBehavior = '';
      sync();
      track.classList.remove('is-fading');
      fading = false;
    }, FADE_MS);
  }
  function tick() {
    if (fading) return;
    var i = current();
    if (i < n - 1) { goTo(i + 1); return; }
    passes++;
    fadeToStart();
    if (passes >= MAX_PASSES) { done = true; stopAuto(); }
  }
  function startAuto() {
    if (reduce || userStopped || done || !visible || n < 2 || timer) return;
    timer = setInterval(tick, AUTO);
  }
  function userStop() { userStopped = true; stopAuto(); }
  ['pointerdown', 'touchstart', 'wheel'].forEach(function (t) { gal.addEventListener(t, userStop, { passive: true }); });
  gal.addEventListener('mouseenter', stopAuto);
  gal.addEventListener('mouseleave', startAuto);
  document.addEventListener('visibilitychange', function () { if (document.hidden) stopAuto(); else startAuto(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) startAuto(); else stopAuto();
    }, { threshold: 0.5 }).observe(gal);
  } else { visible = true; startAuto(); }
})();
